import { invokeHttp } from './api'

export const create = (careplan) =>
  invokeHttp('/admin/patient/care/plan/create', careplan)

export const update = (careplan) =>
  invokeHttp('/admin/patient/care/plan/update', careplan)

export const enable = (id) =>
  invokeHttp('/admin/patient/care/plan/enable', { id })

export const disable = (id) =>
  invokeHttp('/admin/patient/care/plan/disable', { id })

export const deleteCarePlan = (id) =>
  invokeHttp('/admin/patient/care/plan/delete', { id })

export const list = (patientId, page) =>
  invokeHttp('admin/patient/care/get', { patientId, page })
